/**
 * @component {"type":"SecondColumnContent","version":"1.0"}
 * @component {"type":"UITexts","version":"1.0"}
 * @component {"type":"CustomUITexts","version":"1.0"}
 * @component {"type":"ShortTexts","version":"1.0"}
 * @component {"type":"TextMatrices","version":"1.0"}
 * @component {"type":"FormattedTexts","version":"1.0"}

 * @component {"type":"Feedbacks","version":"1.0"}
 * @component {"type":"CustomModals","version":"1.0"}
 * @component {"type":"EvaluateTask","version":"1.0"}
 */

define('trainingVM',['jquery', 'knockout', 'knockout-mapping', 'helpers', 'utils', 'training', 'user-answers', 'feedback', 'modal', 'dialog-manager', 'pagination', 'comment-tool', 'navigation', 'store', 'pubsub', 'validation', 'tooltip', 'dropkick', 'nouislider', 'plyr'],
    function($, ko, mapping, helpers, utils, Training, UserAnswers, Feedback, Modal, Dialog, Pagination, commentTool, Navigation, Store, PubSub, validation, Tooltip) {
        'use strict';

        return function(viewModel, dataContext) {
            var self                = this,
                data                = dataContext.learning,
                user                = null,
                userVM              = viewModel.user,
                entityVM            = viewModel.entity,
                lang                = null,
                modal               = null,
                computedQuizMap     = [],
                timeoutID; // used for forward

            if (!data || !data.current) {
                return;
            }

            self.dataContext = dataContext;

            self.course = {};

            user        = data.user;
            lang        = data.lang;

            var store = Store.default,
                navigation = new Navigation(),
                training = new Training(),
                feedback = new Feedback(),
                dialog = new Dialog(),
                userAnswers = new UserAnswers(),
                tooltip = new Tooltip(),
                validatePage = validation.default;

            /* TrainingVM properties */
            self.componentsJSON = ko.computed(function() {
                return training.componentsJSON;
            });

            self.contentContainerID = ko.observable(training.containerID);

            self.description = ko.computed(function() {
                return (data.training.description) ? data.training.description.trim() : '';
            });

            self.enforceSequence = ko.observable(data.training.enforceSequence);
            self.imagePosition = ko.observable(data.training.imagePosition);
            self.imageScaleMode = ko.observable(data.training.imageScaleMode);
            self.trainingContentEntities = ko.observable(data.training.contentEntities);
            self.alternativeNavigation = ko.observable(false);
            self.notificationItems = ko.observableArray();
            self.savedAnswers = ko.observable('none');
            self.showUnlockButton = ko.observable(false);

            /* END TrainingVM properties */

            /* TrainingVM methods */
            self.getEntity = function(ID) {
                return training.getEntity(ID);
            }

            self.getMediaURL = function(imageID) {
                return training.getMediaURL(imageID);
            }

            self.parseMediaURL = function(imageURL) {
                return training.parseMediaURL(imageURL);
            }
            /* END TrainingVM methods */

            /* Compatibility */

            self.name = entityVM.name;
            self.title = entityVM.title;
            self.entityTitle = entityVM.pageTitle;
            self.parentId = entityVM.parentId;
            self.entityParents  = entityVM.parents;
            self.content = entityVM.content;
            self.text = entityVM.text;
            self.ID = entityVM.ID;
            self.contentEntityId = entityVM.ID;
            self.defaultNaviTargetId = entityVM.naviTargetId;
            self.naviTargetId = entityVM.naviTargetId;
            self.typeId = entityVM.typeId;
            self.displayMode = entityVM.displayMode;
            self.freeTextAnswerId = entityVM.freeTextAnswerId;
            self.showDontKnowOption = entityVM.showDontKnowOption;
            self.leftColumnTitle = entityVM.leftColumnTitle;
            self.rightColumnTitle = entityVM.rightColumnTitle;
            self.passAlways = entityVM.passAlways;
            self.passThreshold = entityVM.passThreshold;
            self.passedFeedback = entityVM.passedFeedback;
            self.failedFeedback = entityVM.failedFeedback;
            self.enableMovingBackwards = entityVM.enableMovingBackwards;
            self.completeDespiteResults = entityVM.completeDespiteResults;
            self.requiresCompletion = entityVM.requiresCompletion;
            self.taskCountToAsk = entityVM.taskCountToAsk;
            self.taskCountToShow = entityVM.taskCountToShow;
            self.canSubmitMultipleTimes = entityVM.canSubmitMultipleTimes;
            self.requiresAnswer = entityVM.requiresAnswer;
            self.hasCorrectAnswers = entityVM.hasCorrectAnswers;
            self.correctAnswerFeedbackId = entityVM.correctAnswerFeedbackId;
            self.incorrectAnswerFeedbackId = entityVM.incorrectAnswerFeedbackId;
            self.answerScoreCaption = entityVM.answerScoreCaption;
            self.answerNoOpinionCaption = entityVM.answerNoOpinionCaption;
            self.answers = entityVM.answers;
            self.questions = entityVM.questions;
            // self.childrens = entityVM.childrens;
            self.componentsJson = entityVM.componentsJson;
            self.components = entityVM.components;

            self.isQuizPage = entityVM.isQuizPage;
            self.isQuizTask = entityVM.isQuizTask;
            /* END Compatibility */


            // These are used in pagination but could be removed and use training module's modularMenuPageID
            self.returnFromSections = false;
            self.returnFromSectionsId;

            self.lang           = ko.observable(lang);

            self.allowKeyboardShorts = ko.observable(true);

            self.isTaskAnswered = ko.observable(false);

            self.contentText = ko.computed(function() {
                var ID = entityVM.ID(),
                    entity = training.getContent(ID);

                return helpers.misc.replaceTextholder(self, userVM, entity.content || entity.text);
            });

            // self.allAnswersRequired     = ko.observable(true);
            self.quizRestarting         = ko.observable(false);

            self.showCorrectAnswers     = ko.observable(false);
            self.answersEnabled         = ko.observable(true);

            self.isValid                = ko.observable(false);

            self.showRestartQuizButton  = ko.observable(false);

            var componentsJson = data.training.componentsJson || '[]';

            self.course.componentsJson = ko.observable(componentsJson);
            self.course.components = ko.observable(helpers.content.convertComponents(JSON.parse(self.course.componentsJson())));

            self.updateTraining = function(trainingData){
                this.training = trainingData;
                self.trainingContentEntities(trainingData.contentEntities);

                // Remove old structure and add new
                self.trainingMap.removeAll();
                ko.utils.arrayPushAll(self.trainingMap, helpers.content.getTrainingMap(trainingData.contentEntities));

                // Update page count
                self.total(self.trainingMap().length);

                // dataContext.updateVM(entityVM.ID());
            };

            self.trainingMap = ko.observableArray(helpers.content.getTrainingMap(self.trainingContentEntities()));

            self.getComponents = function(self){
                return helpers.content.componentObject.getComponents(self);
            };

            self.getComponentsOfPageByKind = function(page, kind) {
                return helpers.content.componentObject.getComponentsOfPageByKind(page, kind);
            };

            // Search components by kind from page and course
            self.getComponentsByKind = function(kind) {
                return entityVM.getComponentsByKind(kind).concat(helpers.content.componentObject.getComponentsByKind(self.course, kind));
            };

            // Search param by name from all page's components
            self.getComponentParamValuesByName = function(name) {
                return helpers.content.componentObject.getComponentParamValuesByName(self, name);
            };

            if (training.scormPackage) {
                require(['scormPackage'], function(ScormPackage) {
                    var scormPackage = new ScormPackage();

                    scormPackage.update(training);
                });
            }

            self.getTasksAndAnswers = function() {
                return userAnswers.getTasksAndAnswers();
            };

            self.isTask = ko.computed(function() {
                return entityVM.isTaskPage();
            });

            self.quizMap = ko.computed(function() {
                var progress = userAnswers.getQuizProgress(entityVM.ID());

                computedQuizMap = (progress) ? progress.childrenID : [];

                return computedQuizMap;
            });

            var interacted = false;

            self.updateVisited = function(ID, entity) {
                var uninteracted = document.querySelectorAll('[data-interacted="false"]').length;

                ID = ID || entityVM.ID()
                entity = entity || training.getEntity(ID);

                if (training.scormPackage) {
                    require(['scormPackage'], function(ScormPackage) {
                        var scormPackage = new ScormPackage();

                        scormPackage.setEntity(ID);
                        scormPackage.setQuizMap(computedQuizMap);
                    });
                }

                if (uninteracted > 0) {
                    return;
                }

                if (!interacted) {
                    PubSub.publish('interaction-complete', {entity: entity});
                    interacted = true;

                    if (!training.scormPackage || !helpers.entity.isTaskPage(entity)) {
                        var props = helpers.state.getProps(store.getState());

                        if (!props.isInactive) {
                            userAnswers.logVisited(ID);
                            dataContext.logProgress('visited', ID);
                        }
                    }

                    if (!training.scormPackage) {
                        return;
                    }

                    require(['scormPackage'], function(ScormPackage) {
                        var scormPackage = new ScormPackage();
                        scormPackage.setLocation(ID);
                        scormPackage.setSuspend(userAnswers);

                        if (scormPackage.entityIsPage()) {
                            scormPackage.setLessonStatus(userAnswers);
                        }
                    });
                }

            };

            ko.bindingHandlers.updateVisited = {
                init: function() {
                    self.entityChanged = ko.computed(function() {
                        var content = entityVM.entityContent(),
                            ID = content.ID,
                            entity = training.getEntity(ID);

                        interacted = false;

                        PubSub.publish('page-load-complete', {
                            entity: entity,
                            state: training.state
                        });

                        if (ID && !helpers.entity.isQuizPage(entity)) {
                            self.updateVisited(ID, entity);
                        } else if (training.scormPackage) {
                            require(['scormPackage'], function(ScormPackage) {
                                var scormPackage = new ScormPackage();

                                scormPackage.setLocation(ID);
                                scormPackage.setSuspend(userAnswers);
                            });
                        }

                        if (dataContext.debugMode) {
                            console.log('5. updateVisited');
                            console.log('---------  updateVM total: ' + (new Date() - window.initPageRender) + '  ---------');
                        }

                    }).extend({rateLimit: 0});
                },
                after: ['customJS']
            };

            function openFeedback(ID) {
                dialog.open({
                    type: 'feedback',
                    content: feedback.getContent(ID)
                });
            }

            ko.computed(function() {
                var ID = entityVM.ID(),
                    entity = training.getContent(ID),
                    content = training.getComponent('TaskSettings', ID);

                document.body.classList.remove('nav-menu-open');

                self.isTaskAnswered(false);
                self.isValid(false);

                if (timeoutID) {
                    clearTimeout(timeoutID);
                }

                dialog.close({
                    type: ['dialog', 'modal', 'feedback']
                });

                if (entity.typeID === 19) {
                    var progress = userAnswers.getQuizPageProgress(ID);

                    if (progress && (progress.isAnswered && progress.isPassed || progress.isVisited)) {

                        userAnswers.logVisited(ID);

                        dataContext.logProgress('visited', ID);

                        userAnswers.addAnswer(ID, {
                            answered: true,
                            score: progress.userScore,
                            passed: progress.isPassed
                        });
                    }
                }

                // currentUserAnswer = new CurrentUserAnswer(user.answers, ID);

                if (!userAnswers.isTaskPageAnswered(ID) || training.state === 'reload' || training.state === 'reset' || entity.typeID === 19) {
                    self.savedAnswers((training.state === 'reload') ? 'hide' : 'none'); // maybe hide when reload???
                    self.answersEnabled(true);
                    self.showUnlockButton(false);
                    self.showCorrectAnswers(false);
                    return;
                }

                if (!entity.canSubmitMultipleTimes) {
                    self.savedAnswers('none');
                    self.answersEnabled(false);
                    self.showUnlockButton(false);
                    self.showCorrectAnswers(false);

                    setTimeout(function() {
                        if (feedback.contains(entity)) {
                            openFeedback(ID);
                        }
                    }, 0);

                    return;
                }

                if (!Object.keys(content).length || content.resetButton) {
                    self.answersEnabled(false);
                    self.showUnlockButton(true);
                    if (entity.hasCorrectAnswers) {
                        self.showCorrectAnswers(true);
                    }
                } else {
                    self.answersEnabled(true);
                    self.showUnlockButton(false);
                    self.showCorrectAnswers(false);
                }

                if (Object.keys(content).length) {
                    if (content.showSavedAnswers) {
                        self.savedAnswers('show');
                    } else if (content.showSavedAnswers === false) {
                        self.savedAnswers('hide');
                    } else {
                        self.savedAnswers('none');
                    }
                }
            });

            ko.computed(function() {
                var isTaskAnswered = self.isTaskAnswered();

                if (!isTaskAnswered) {
                    return;
                }

                var state = store.getState(),
                    props = helpers.state.getProps(state),
                    settings = helpers.state.getComponent(state, 'tasksettings') || {};

                if (!state.entity.canSubmitMultipleTimes || training.state === 'reload' || training.state === 'reset' || props.isQuizPage || props.isQuizSubpage || props.isQuizGamePage || props.isQuizGameSubpage) {
                    return;
                }

                if (!Object.keys(settings).length || settings.resetButton) {
                    self.showUnlockButton(true);
                }
            })

            self.computedAnswers = ko.computed(function() {
                var ID = entityVM.ID(),
                    entity = training.getEntity(ID) || {};

                if (!Array.isArray(entity.answers) || !entity.answers.length) {
                    return [];
                }

                if (entity.contentEntity.shuffleOptions && training.state !== 'reset' && self.answersEnabled() && (entity.contentEntity.canSubmitMultipleTimes || !userAnswers.isTaskPageAnswered(ID))) {
                    entity.answers.shuffle();
                }

                return entity.answers;
            }).extend({deferred: true});

            self.computedQuestions = ko.computed(function() {
                var ID = entityVM.ID(),
                    entity = training.getEntity(ID) || {},
                    questions = Array.isArray(entity.questions) ? entity.questions : [];

                if (!questions.length || entity.typeId !== 15 || training.state === 'reset' || !entity.contentEntity.shuffleOptions) {
                    return questions;
                }

                if (self.answersEnabled() && training.state !== 'reset' && (entity.contentEntity.canSubmitMultipleTimes || !userAnswers.isTaskPageAnswered(ID)) && (entity.typeId !== 15 || training.state !== 'init')) {
                    questions.shuffle();
                }

                return questions;
            }).extend({deferred: true});

            self.sliderAnswers = ko.computed(function() {
                var ID = entityVM.ID(),
                    entity = training.getEntity(ID),
                    answers = (entity && Array.isArray(entity.answers)) ? entity.answers.slice(0) : [];

                return answers.sort(function(a, b) {
                    if (a.orderNum < b.orderNum) {
                        return -1;
                    } else if(b.orderNum < a.orderNum) {
                        return 1;
                    }
                    return 0;
                }).filter(function(answer) {
                    return (answer.text !== '-');
                }).map(function(answer) {
                    return answer.text;
                });
            });

            self.showActionButtons = ko.computed(function() {
                var entity = training.getContent(entityVM.ID()),
                    content;

                switch(entity.typeID) {
                case 10: // Content Page
                    return false;
                case 13:
                    switch(entity.displayMode) {
                        case 4: // Push buttons
                            return false;
                        default:
                            return true;
                    }
                case 14:
                    switch(entity.displayMode) {
                        case 8: // Push buttons
                            return false;
                        default:
                            return true;
                    }
                case 19: // Quiz
                    return false;
                case 20: // Sort to groups
                    content = helpers.component.getContent(entity.componentsJSON, 'sortToGroups');

                    return (content.submit === false) ? false : true;
                default:
                    return true;
                }
            });

            self.showResetButton = ko.computed(function() {
                var entity = training.getEntity(entityVM.ID());

                return (entity && entity.typeId === 15) ? true : false;
            });

// ------------- Validation -------------

            self.validate = function() {
                var ID = entityVM.ID();

                if (self.canSubmitMultipleTimes() && !userAnswers.isTaskPageAnswered(ID)) {
                    dialog.close({
                        type: 'feedback'
                    });
                }

                self.isValid(validatePage(store.getState().entity));


                // console.log("validate", validatePage(store.getState().entity));
                // console.log("validate2", store.getState().entity);

                return true; // used for default behavious
            };

// ------------- END Validation -------------

            self.canSubmit = ko.computed(function() {
                return ( ((entityVM.isQuizPage() || entityVM.isQuizGame()) || self.isValid()) && self.answersEnabled() ) ? true : false;
            });

// ------------- get Text By Content Entity ID  -------------

// can be moved to content helpers???
            self.getContentEntityNameByID = function(ID) {
                var entity = training.getEntity(ID);

                if (entity === null) {
                    return '';
                }

                return (entity.contentEntity.hasOwnProperty('name')) ? entity.contentEntity.name : '';
            };

            self.getContentEntityTextByID = function(ID) {
                var entity = training.getEntity(ID);

                if (entity === null) {
                    return '';
                }

                return (entity.contentEntity.hasOwnProperty('text')) ? entity.contentEntity.text : (entity.contentEntity.hasOwnProperty('content')) ? entity.contentEntity.content : '';
            };

// ------------- Custom texts  -------------

            self.customText = function(textID, index, contentEntityId) {
                return helpers.content.customText.getCustomText(self, textID, index, contentEntityId);
            };

            self.customCourseText = function(textID, index) {
                return helpers.content.customText.getCustomText(self.course, textID, index);
            };

// ----------- End custom texts  -----------


// ------------- Custom points  -------------

            self.setCustomPoints = function(points, overwrite) {

                if (!dataContext.offlinePackage && utils.onLine) {
                    return helpers.User.customPoints.setCustomPoints(self, points, overwrite);
                } else {
                    return;
                }
            };

// ----------- End custom points  -----------


// ------------- List top score learners  -------------

            self.getTopScoreLearners = function(take, cbFunc) {

                if (!dataContext.offlinePackage && utils.onLine) {
                    return helpers.User.customPoints.getTopScoreLearners(self, take, cbFunc);
                } else {
                    return;
                }
            };

// ------- End list top score learners ------

// ------------- Get current user score   -------------

            self.getCurrentUserScore = function(cbFunc) {

                if (!dataContext.offlinePackage && utils.onLine) {
                    return helpers.User.customPoints.getCurrentUserScore(self, cbFunc);
                } else {
                    return;
                }
            };

// ------- End get current user score ------

// ------------- User Custom Storage -------------

            self.setCustomStorageData = function(key, value, global, cbFunc) {

                if (!dataContext.offlinePackage && utils.onLine) {
                    return helpers.User.customStorage.setCustomStorageData(dataContext, key, value, (global ? null : entityVM.ID()), cbFunc);
                } else {
                    return;
                }
            };

            self.getCustomStorageData = function(key, global, cbFunc) {

                if (!dataContext.offlinePackage && utils.onLine) {
                    return helpers.User.customStorage.getCustomStorageData(dataContext, key, (global ? null : entityVM.ID()), cbFunc);
                } else {
                    return;
                }
            };

            self.removeCustomStorageData = function(key, global, cbFunc) {

                if (!dataContext.offlinePackage && utils.onLine) {
                    return helpers.User.customStorage.removeCustomStorageData(dataContext, key, (global ? null : entityVM.ID()), cbFunc);
                } else {
                    return;
                }
            };

// ----------- End User Custom Storage -----------

// ------------- Show custom modal   -------------

            self.showModal = function(modalData, btnMainFunc, btnSecondFunc) {
                var modalShown = false,
                    title,
                    body,
                    buttons = [],
                    btn1Text,
                    btn2Text;

                if(modalData) {
                    if (btnSecondFunc) {
                        btn2Text = (modalData.btnSecond) ? modalData.btnSecond : lang.cancel;
                    }
                    btn1Text = (modalData.btnMain) ? modalData.btnMain : lang.ok;

                    body = modalData.text;
                    title = modalData.header;

                    if (body) {
                        modal = new Modal({
                            content: body,
                            label: title,
                            enterClose: true,
                            showClose: false
                        });

                        buttons = [{
                            action: function () {
                                if (btnMainFunc) btnMainFunc()
                                modal.close();
                            },
                            class: 'bu bu-alt', text: btn1Text
                        }
                        ];
                        if (btn2Text) {
                            buttons.push({
                                action: function () {
                                    if (btnSecondFunc) btnSecondFunc()
                                    modal.close();
                                },
                                class: 'bu bu-alt', text: btn2Text
                            });
                        }
                        modal.addButtons(buttons);
                        modal.addClass("custom-modal");

                        modal.open();
                        modalShown = true;
                    }
                }
                return modalShown;
            };

            self.showCustomModal = function(index, btnMainFunc, btnSecondFunc) {
                var modalShown = false,
                    modalData,
                    component = self.getComponentsByKind('CustomModals');

                if(component.length > 0) {
                    modalData = component[0].content.items[index-1].content;
                    modalShown = self.showModal(modalData, btnMainFunc, btnSecondFunc);
                }
                return modalShown;
            };

            self.showCustomCourseModal = function(index, btnMainFunc, btnSecondFunc) {
                var modalShown = false,
                    modalData,
                    component = helpers.content.componentObject.getComponentsByKind(self.course, 'CustomModals');

                if(component.length > 0) {
                    modalData = component[0].content.items[index-1].content;
                    modalShown = self.showModal(modalData, btnMainFunc, btnSecondFunc);
                }
                return modalShown;
            };

// ------- End Show custom modal ------

            // used to set name attribute for radio/ checkbox in multichoice task
            self.getQuestionId = function() {
                var questions = entityVM.questionsJS(),
                    questionID = '';

                questions.forEach(function(question) {
                    questionID = question.id;
                });

                return questionID;
            };

            self.options = function(id) {
                var answers     = self.answers(),
                    arr         = [],
                    ID = '',
                    text = '';

                answers.forEach(function(el) {
                    if (id === el.questionId()) {
                        ID = el.id();
                        text = (userVM.hasRoles(['superadmin', 'coursehost', 'composeruser']) || dataContext.debugMode) ? el.text() + (self.isAnswerCorrect(el.id()) ? '<span class="dk-hint">*</span>' : '') : el.text();

                        arr.push({'id': ID, 'text': text});
                    }
                });

                return arr;
            };

            ko.bindingHandlers.taskContent = {
                init: function() {
                    return {
                        controlsDescendantBindings: true
                    };
                },
                update:function(container, valueAccessor, allBindings, viewModel, bindingContext) {
                    var options = valueAccessor() || {},
                        parseQuestions = function(arr) {
                            var i = arr.length,
                                obj = {};

                            while(i--) {
                                obj['blank' + arr[i].orderNum] = arr[i].id;
                            }

                            return obj;
                        };

                    switch(options.typeID) {
                        case 18:
                            var contentHolder = document.createElement('div'),
                                dataQuestions = parseQuestions(self.computedQuestions());

                            contentHolder.innerHTML = self.contentText();

                            $('input', $(contentHolder)).each(function() {
                                var $item = $(this),
                                    itemID = $item.attr('id'),
                                    caption = $item.attr('defaultvalue') || $item.attr('value'),
                                    options = [],
                                    $select = null,
                                    trigger = self.isTaskAnswered();

                                if (!caption || !dataQuestions[itemID]) {
                                    return;
                                }

                                options = self.options(dataQuestions[itemID]);

                                if (options.length) {
                                    $select = $('<select/>').attr({
                                        'id': dataQuestions[itemID],
                                        'name': dataQuestions[itemID],
                                        'class': 'js-select',
                                        'data-bind' :
                                        'options: $root.training.options("' + dataQuestions[itemID] + '"), ' +
                                        'optionsText: "text", ' +
                                        'optionsValue: "id", ' +
                                        'optionsCaption: "'+ caption +'", ' +
                                        'value: $root.training.getAnswerIdByQuestionId("' + dataQuestions[itemID] + '"), ' +
                                        'enable: $root.training.answersEnabled, ' +
                                        'css: $root.training.rowClass(\'f-row-fill-blanks\', $root.training.getAnswerIdByQuestionId("' + dataQuestions[itemID] + '") )'
                                    });
                                } else {
                                    $select = $('<select/>').attr({
                                        'class': 'js-select-disabled',
                                        'value': caption,
                                        'disabled': 'disabled',
                                        'data-bind' :
                                        'optionsCaption: "'+ caption +'", ' +
                                        'options: "'+ caption +'"'
                                    });
                                }

                                $item.after($select).remove();
                            });

                            container.innerHTML = contentHolder.innerHTML;
                            break;
                        default:
                            return false;
                    }

                    ko.applyBindingsToDescendants(bindingContext.createChildContext(bindingContext.$rawData), container);

                    if (utils.isFunction($.fn.dropkick)) {

                        $('.js-select-disabled').each(function() {
                            var $this = $(this);
                            try {
                                $this.dropkick();
                            } catch (e) {}
                        });

                        $('.js-select').each(function() {
                            var $this = $(this);
                            try {
                                $this.dropkick({
                                    change: self.validate
                                });
                            } catch (e) {}
                        });
                    }
                }
            };

            self.getArrPropByIndex = function(index, prop, arr) {
                var i   = parseInt(index, 10);
                return ( arr && arr.length > index && !!prop && arr[i].hasOwnProperty(prop) ) ? arr[i][prop] : '';
            };

// ------------- User Answers -------------

            function getOrderNo(questionID) {
                var answers = entityVM.answersJS(),
                    answerID = self.getAnswerIdByQuestionId(questionID),
                    orderNo = '';

                if (!answerID) {
                    return orderNo;
                }

                answers.forEach(function(answer) {
                    if (answerID === answer.id) {
                        orderNo = answer.orderNum;
                    }
                });

                return orderNo;
            }

            var showAnswers = function() {
                return (!self.answersEnabled() || self.showCorrectAnswers() || self.savedAnswers() === 'show') ? true : false;
            }

            self.isNotKnowOptionChecked = function(ID) {
                return (showAnswers()) ? !userAnswers.getAnswerProp(entityVM.ID(), 'answerId', 'questionId', ID) : false;
            };
            self.isAnswerValueEqual = function(ID) {
                return (showAnswers() && userAnswers.getAnswerProp(entityVM.ID(), 'answerId', 'answerId', ID)) ? true : false;
            };
            self.getAnswerIdByQuestionId = function(ID) {
                return (showAnswers()) ? userAnswers.getAnswerProp(entityVM.ID(), 'answerId', 'questionId', ID) : '';
            };

            self.getAnswersIdByQuestionId = function(questionID) { // Could be removed
                if (!showAnswers()) {
                    return '';
                }

                var answers = userAnswers.getUserAnswers(entityVM.ID()),
                    res = [];

                answers.forEach(function(answer) {
                    if (answer.questionId === questionID) {
                        res.push(answer.answerId);
                    }
                });

                return res;
            };
            self.getAnswerTextByQuestionId = function(ID) {
                return (showAnswers()) ? userAnswers.getAnswerProp(entityVM.ID(), 'answerText', 'questionId', ID) : '';
            };
            self.getAnswerTextByQuestionIdAlways = function(ID) {
                return (self.savedAnswers() === 'hide') ? '' : userAnswers.getAnswerProp(entityVM.ID(), 'answerText', 'questionId', ID);
            };
            self.getAnswerTextByAnswerId = function(ID) {
                return (showAnswers()) ? userAnswers.getAnswerProp(entityVM.ID(), 'answerText', 'answerId', ID) : '';
            };
            self.getAnswerTextByAnswerIdAlways = function(ID) {
                return (self.savedAnswers() === 'hide') ? '' : userAnswers.getAnswerProp(entityVM.ID(), 'answerText', 'answerId', ID);
            };
            self.getQuestionIdByAnswerId = function(ID) {
                return (showAnswers()) ? userAnswers.getAnswerProp(entityVM.ID(), 'questionId', 'answerId', ID) : '';
            };
            self.getAnswerOrderNoByQuestionId = function(questionID) {
                if (training.state === 'reset' || training.state === 'reload') {
                    return '';
                }

                return getOrderNo(questionID);
            }

// ------------- END User Answers -------------

// ------------- Show (in)Correct Answers -------------

            self.colClass = function(type, parentID, ID, correct) {
                var colClass = [];

                if ( !self.answersEnabled() || self.showCorrectAnswers()) {
                    if (type === 'f-col-yes-no') {
                        colClass.push('f-col-' + self.answerStateYesNo(parentID, ID));
                    } else if (type === 'f-col-yes-no-boxes') {
                        colClass.push((self.getAnswerIdByQuestionId(parentID) === ID) ? 'f-col-button-' + self.answerStateYesNo(parentID, ID) + '-checked' : 'f-col-button-' + self.answerStateYesNo(parentID, ID));
                    } else if (type === 'f-col-match-pair') {
                        if (correct) {
                            colClass.push('f-col-correct');
                        } else {
                            colClass.push('f-col-' + self.questionState(ID));
                        }
                    }
                } else if (self.answersEnabled()) {
                    if (type === 'f-col-yes-no-boxes') {
                        colClass.push('f-col-active');
                    }

                    if (self.savedAnswers() === 'show') {
                        if (type === 'f-col-yes-no-boxes' && self.getAnswerIdByQuestionId(parentID) === ID) {
                            colClass.push('f-col-button-saved-checked');
                        }
                    }

                }

                if (userVM.hasRoles(['superadmin', 'coursehost', 'composeruser']) || dataContext.debugMode) {

                    if (self.isYesNoAnswerCorrect(parentID, ID)) {
                        colClass.push('f-col-hint');
                    }
                }

                return colClass.join(' ');
            };

            self.rowClass = function(type, ID, status) {
                var rowClass = [];

                if (self.showCorrectAnswers() || !self.answersEnabled() && self.hasCorrectAnswers()) {
                    if (type === 'f-row-radio' || type === 'f-row-button') {
                        rowClass.push((ID === status) ? 'f-row-' + self.answerState(ID) + '-checked' : 'f-row-' + self.answerState(ID));
                    } else if (type === 'f-row-yes-no' || type === 'f-row-set-in-order') {
                        rowClass.push('f-row-' + self.questionState(ID) + '-checked');
                    } else if (type === 'f-row-yes-no-boxes') {
                        rowClass.push('box-inner-' + self.questionState(ID));
                    } else if (type === 'f-row-fill-blanks') {
                        rowClass.push('f-row-' + self.answerState(ID));
                    } else if (type === 'f-row-match-pair') {
                        rowClass.push('');
                    } else if (type === 'f-row-public') {
                        rowClass.push('');
                    } else if (type === 'f-row-sort') {
                        rowClass.push('f-row-' + self.sortToGroupsStatus(ID, status) + '-checked');
                    } else {
                        rowClass.push((status) ? 'f-row-' + self.answerState(ID) + '-checked' : 'f-row-' + self.answerState(ID));
                    }
                } else if (self.answersEnabled()) {

                    if (type !== 'f-row-yes-no-boxes') {
                        rowClass.push('f-row-active');
                    }

                    if (self.savedAnswers() === 'show') {
                        if (type === 'f-row-button') {
                            if (ID === status) {
                                rowClass.push('f-row-saved-checked');
                            }
                        } else if (type === 'f-row-yes-no-boxes') {
                            rowClass.push('box-inner-' + self.questionState(ID));
                        } else if (type === 'f-row-set-in-order') {
                            rowClass.push('f-row-set-in-order-alt');
                        }
                    }

                } else if (!self.answersEnabled()) {
                    if (type === 'f-row-button') {
                        rowClass.push((ID === status) ? 'f-row-answered-checked' : 'f-row-answered');
                    } else if (type === 'f-row-yes-no-boxes') {
                        rowClass.push('box-inner-answered');
                    } else {
                        rowClass.push('f-row-answered');
                    }
                }

                if (userVM.hasRoles(['superadmin', 'coursehost', 'composeruser']) || dataContext.debugMode) {
                    if (self.isAnswerCorrect(ID)) {
                        rowClass.push('f-row-hint');
                    }
                }

                if (type === 'f-row-yes-no' && entityVM.containsStatistics() && self.isTaskAnswered() || !self.answersEnabled()) {
                    rowClass.push('f-row-social');
                }

                return rowClass.join(' ');
            };

            self.isQuestionCorrect = function(questionID) {
                var i = 0,
                    ID = entityVM.ID(),
                    answers = userAnswers.getUserAnswers(ID),
                    answerID = '',
                    questions = entityVM.questionsJS();

                for (i = 0; i < answers.length; i++) {
                    if (questionID === answers[i].questionId) {
                        answerID = answers[i].answerId;
                    }
                }

                for (i = 0; i < questions.length; i++) {
                    if (questionID === questions[i].id && answerID === questions[i].correctAnswerId) {
                        return true;
                    }
                }

                return false;
            };

            self.isAnswerCorrect = function(answerID) {
                var answers = entityVM.answersJS();

                for (var i = 0; i < answers.length; i++) {
                    if (answers[i].id === answerID && answers[i].points > 0) {
                        return true;
                    }
                }

                return false;
            };

            self.isYesNoAnswerCorrect = function(questionID, correctAnswerID) {
                var questions = entityVM.questionsJS(),
                    i = questions.length;

                while(i--) {
                    if (questions[i].id === questionID && questions[i].correctAnswerId === correctAnswerID) {
                        return true;
                    }
                }

                return false;
            };

            self.questionState = function(questionID) {
                var ID = entityVM.ID();

                if ( self.hasCorrectAnswers() && ( !self.canSubmitMultipleTimes() || self.showCorrectAnswers() ) && userAnswers.isTaskPageAnswered(ID) ) {
                    return ( self.isQuestionCorrect(questionID) ) ? 'correct' : 'incorrect';
                } else if (userAnswers.isTaskPageAnswered(ID) && !self.showCorrectAnswers()) {
                    return 'answered';
                }
            };

            self.answerState = function(answerID) {
                var ID = entityVM.ID();

                if ( self.hasCorrectAnswers() && ( !self.canSubmitMultipleTimes() || self.showCorrectAnswers() ) && userAnswers.isTaskPageAnswered(ID) ) {
                    return ( self.isAnswerCorrect(answerID) ) ? 'correct' : 'incorrect';
                } else if (userAnswers.isTaskPageAnswered(ID) && !self.showCorrectAnswers()) {
                    return 'answered';
                }

                return '';
            };

            self.answerStateYesNo = function(answerID, correctAnswerID) {
                var ID = entityVM.ID();

                if ( self.hasCorrectAnswers() && ( !self.canSubmitMultipleTimes() || self.showCorrectAnswers() ) && userAnswers.isTaskPageAnswered(ID) ) {
                    return ( self.isYesNoAnswerCorrect(answerID, correctAnswerID) ) ? 'correct' : 'incorrect';
                } else if (userAnswers.isTaskPageAnswered(ID) && !self.showCorrectAnswers()) {
                    return 'answered';
                }

                return '';
            };

            self.isQuizPassed = ko.computed(function() {

            });

// ------------- END Show (in)Correct Answers -------------

// ------------- Action Buttons -------------

            $('#form').submit(function (e) {
                e.preventDefault();
            });

            self.resetForm = function(reload) {
                var ID = entityVM.ID(),
                    entity = training.getEntity(ID);

                window.initPageRender = new Date();

                training.setState((reload === true) ? 'reload' : 'reset');

                store.dispatch({
                    type: 'SET_ENTITY',
                    payload: {
                        ID: ID
                    }
                });

                PubSub.publish('page-load-init', {
                    entity: entity,
                    state: training.state
                });

                entityVM.ID.valueHasMutated();
                self.validate();
            };

            self.buttonClick = function(obj) {
                if ( self.answersEnabled() ) {
                    self.isValid(true);
                    self.submitForm({name: self.getQuestionId(), value: obj.id});
                }

                return true;
            };

            self.forceSubmitForm = function() {
                self.isValid(true);
                self.submitForm();
            };

            self.submitForm = function(obj, e, arr) {
                var i                   = 0,
                    j                   = 0,
                    submittedAnswers    = $('#content').serializeArray(),
                    answers             = self.answers(),
                    answerId            = '',
                    answersLen          = answers.length,
                    questions           = self.questions(),
                    questionId          = '',
                    questionsLen        = questions.length,
                    raiseAlert          = false,
                    alertText           = lang.answerMissing;

                var ID = self.ID(),
                    entity = training.getContent(ID),
                    progress = null,
                    parentID = entity.parentID;

                arr = arr || [];

                if (obj) {
                    submittedAnswers.push(obj);
                }

                for (var a = 0; a < arr.length; a++) {
                    submittedAnswers.push(arr[a]);
                }

                if (self.typeId() === 13 && entityVM.displayMode() === 3) { // MultiChoice & checkbox

                    var count = helpers.User.getMultipleChoiceSelectedOptionsCount(answers);

                    var comps = helpers.content.componentObject.getComponentsByKind(self, "CheckboxMinMax");
                    if(comps && comps.length > 0){
                        // there might be minAnswers & maxAnswers
                        var comp = comps[0],
                            min = comp.content.min,
                            max = comp.content.max;

                        if(min){
                            if(min > count) raiseAlert = true;
                        }
                        if(max){
                            if(max < count) raiseAlert = true;
                        }
                        if(raiseAlert) alertText = comp.content.alert;
                    }
                }

                if ( self.isValid() && !raiseAlert ) {
                    var checkbox = document.getElementById('is-public'),
                        isPublic = (checkbox && checkbox.checked) ? true : false;

                    userAnswers.logProgress(ID, {answers: []});

                    if ( self.typeId() === 16 && arr.length === 0 ) { // match pair task

                        while (i < answersLen) {
                            answerId = answers[i].id();

                            if (questionsLen) {
                                j = 0;
                                while (j < questionsLen) {
                                    questionId = questions[j].id();

                                    if ( $('#' + answerId).has('#' + questionId).length ) {

                                        userAnswers.addAnswer(ID, {
                                            answerId: answerId,
                                            answerText: '',
                                            questionId: questionId
                                        });
                                    }

                                    j++;
                                }
                            }

                            i++;
                        }

                    } else if ( self.typeId() === 20 ) { // sort to groups task

                        while(questionsLen--) {
                            questionId = questions[questionsLen].id();

                            $('#' + questionId).find('.js-sort-answer').each(function() {

                                answerId = $(this).attr('id');

                                userAnswers.addAnswer(ID, {
                                    answerId: answerId,
                                    answerText: '',
                                    questionId: questionId
                                });
                            });
                        }

                    } else if ( self.typeId() === 16 && arr.length ) {

                        submittedAnswers.forEach(function(answer) {
                            if (answer.value && answer.name) {
                                userAnswers.addAnswer(ID, {
                                    answerId: answer.value,
                                    answerText: '',
                                    questionId: answer.name,
                                    isPublic: isPublic
                                });
                            }
                        });

                    } else {
                        questions.forEach(function(question) {
                            var questionId = question.id();

                            submittedAnswers.forEach(function(answer) {

                                if ( !answer.hasOwnProperty('name') || !answer.hasOwnProperty('value') ) {
                                    return;
                                }

                                var answerName  = answer.name,
                                    answerValue = answer.value,
                                    freeText    = '';

                                if (!answerName && !answerValue) {
                                    return false;
                                }

                                if ( self.typeId() === 12 ) { // open question task
                                    freeText    = answerValue;
                                    answerValue = answerName;
                                }

                                if ( answerName === questionId || self.typeId() === 12 ) {
                                    if (questionId === answerValue) { // Evaluate task, I don't know option
                                        answerValue = null;
                                    }

                                    submittedAnswers.forEach(function(el) {
                                        if (el.name === questionId + '-free-text') {
                                            if ( el.value ) {
                                                freeText = el.value;
                                            }
                                        }
                                    });

                                    if ( self.typeId() === 15 ) { // set in order task

                                        i = 0;
                                        while (i < answersLen) {
                                            if ( parseInt( answer.value, 10) === answers[i].orderNum() ) {
                                                answerValue = answers[i].id();
                                                break;
                                            }
                                            i++;
                                        }
                                    }

                                    if (self.typeId() === 18) { // fill in blanks

                                        i = 0;
                                        j = 0;
                                        while (i < answersLen) {
                                            if (questionId === answers[i].questionId()) {
                                                j++;
                                                break;
                                            }
                                            i++;
                                        }

                                        if (j === 0) {
                                            //answerId = questionId;
                                            freeText = answerValue;
                                            answerValue = '';
                                        }
                                    }

                                    if ( self.typeId() === 17 ||  answerValue || freeText ) {   // evaluate
                                        userAnswers.addAnswer(ID, {
                                            answerId: answerValue,
                                            answerText: utils.escapeHTML(freeText),
                                            questionId: questionId,
                                            isPublic: isPublic
                                        });
                                    }

                                }

                            });

                        });

                    }

                    if (training.scormPackage) {

                        if (helpers.entity.isTaskPage(entity)) {
                            userAnswers.logVisited(ID);
                            dataContext.logProgress('visited', ID);
                        }

                        require(['scormPackage'], function(ScormPackage) {
                            var scormPackage = new ScormPackage();

                            scormPackage.setSuspend(userAnswers);
                        });
                    }

                    if ( self.isQuizTask()) {
                        progress = userAnswers.getQuizProgress(ID);

                        if (self.isLastQuizTask(ID)) {
                            if (progress) {

                                if (progress.isAnswered && progress.isPassed) {
                                    userAnswers.logVisited(progress.ID);
                                    dataContext.logProgress('visited', progress.ID);
                                }

                                userAnswers.addAnswer(progress.ID, {
                                    answered: true,
                                    score: progress.userScore,
                                    passed: progress.isPassed
                                });
                            }

                        }
                    }

                    dataContext.logProgress('answers', ID);

                    if (!entityVM.isQuizGame()) {

                        var navigateTo = userAnswers.getTargetID(ID),
                            noFeedbacks = !feedback.contains(entity),
                            showFeedback = function(ID) {
                                self.answersEnabled(false);

                                openFeedback(ID);

                                if (entity.hasCorrectAnswers) {
                                    self.showCorrectAnswers(true);
                                }

                                viewModel.updateVM(ID);
                            };

                        if (navigateTo && noFeedbacks) {

                            if (entity.hasCorrectAnswers) {

                                self.answersEnabled(false);
                                self.showCorrectAnswers(true);

                                viewModel.updateVM(ID);

                                timeoutID = setTimeout(function() {
                                    self.goTo(navigateTo);
                                }, dataContext.forwardDelay);

                            } else {
                                self.goTo(navigateTo);
                            }

                        } else {

                            if (entity.naviTargetID && !entity.hasCorrectAnswers) {

                                if (noFeedbacks) {
                                    self.goTo(entity.naviTargetID);
                                } else {
                                    showFeedback(ID);
                                }

                            } else {
                                showFeedback(ID);
                            }

                        }

                    } // if not quiz game

                    if (entityVM.isTaskPage()) {
                        var taskSettings = helpers.component.getContent(entity.componentsJSON, 'TaskSettings'),
                            answerNotificationText = taskSettings.answerNotificationText,
                            closeIn = taskSettings.closeIn || 0;

                        if (answerNotificationText) {
                            dialog.open({
                                clone: true,
                                container: document.getElementById('notifications'),
                                content: answerNotificationText,
                                showClose: true,
                                overlay: false,
                                mainClass: 'modal modal-notification',
                                closeIn: closeIn * 1000
                            });
                        }
                    }

                    self.isTaskAnswered(true);

                    PubSub.publish('task-answered', {
                        entity: entity,
                        progress: progress
                    });

                } else {

                    modal = new Modal({
                        content: alertText,
                        enterClose: true,
                        showClose: false
                    });

                    modal.addButtons([
                        {action: function() { modal.close(); }, class: 'bu bu-alt', text: lang.ok}
                    ]);

                    modal.open();
                }

                if (training.scormPackage) {

                    require(['scormPackage'], function(ScormPackage) {
                        var scormPackage = new ScormPackage();

                        if (entityVM.isTaskPage()) {
                            scormPackage.setTaskAnswer(self.getEntity(entityVM.ID()), userAnswers);
                        }

                        scormPackage.setLessonStatus(userAnswers);
                    });

                }

                // dataContext.sendProgress();
            };

// ------------- END Action Buttons -------------

            var getOrder = function() {
                var arr = [],
                    entity = training.getEntity(entityVM.ID());

                if (!entity) {
                    return;
                }

                entity.questions.forEach(function(question) {
                    var node = document.getElementById(question.id);

                    if (node && node.value) {
                        arr.push(parseInt(node.value));
                    }
                });

                for (var i = 1; i <= entity.questions.length; i++) {
                    if (arr.indexOf(i) === -1) {
                        return i;
                    }
                }

                return 1;
            };

            self.setInOrderOver = function(data) {
                var questionID = data.id,
                    input = document.getElementById(questionID),
                    row = (input) ? input.parentNode : null;

                if (!self.answersEnabled() || !row || input.value) {
                    return;
                }

                row.setAttribute('data-content', getOrder());
            }

            self.setInOrderOut = function(data) {
                var questionID = data.id,
                    input = document.getElementById(questionID),
                    row = (input) ? input.parentNode : null;

                if (!self.answersEnabled() || !row || input.value) {
                    return;
                }

                row.setAttribute('data-content', '');
            }

            self.setInOrder = function(data) {
                var questionID = data.id,
                    input = document.getElementById(questionID),
                    row = (input) ? input.parentNode : null,
                    cssClass = 'f-row-set-in-order-alt';

                if (!self.answersEnabled() || !row) {
                    return;
                }

                if (input.value) {
                    input.value = '';
                    row.classList.remove(cssClass)
                } else {
                    input.value = getOrder();
                    row.classList.add(cssClass)
                }

                row.setAttribute('data-content', '');

                self.validate();
            };

            self.sortToGroupsStatus = function(id, questionId) {
                var answers = entityVM.answersJS(),
                    answer = {},
                    i = answers.length;

                while(i--) {
                    answer = answers[i];
                    if ( answer.id === id ) {
                        return (answer.questionId === questionId) ? 'correct' : 'incorrect';
                    }
                }

                return '';
            };

            var sliderID = {};
            ko.bindingHandlers.initSlider = {      // For evaluate slider
                update: function(el, valueAccessor) {
                    var ID = entityVM.ID(),
                        questionID = ko.utils.unwrapObservable(valueAccessor()),
                        entity = training.getEntity(ID),
                        answers = entity.answers,
                        $slider = $(el),
                        disabled = (self.answersEnabled()) ? false : true,
                        value = (disabled) ? self.getAnswerOrderNoByQuestionId(questionID) : Math.ceil(answers.length/2);

                    if (!entity || entity.typeId !== 17 || entity.contentEntity.displayMode !== 6) {    //
                        return;
                    }

                    if (sliderID[questionID]) {
                        clearTimeout(sliderID[questionID]);
                    }

                    sliderID[questionID] = setTimeout(function() {

                        if (self.savedAnswers() === 'show') {
                            value = getOrderNo(questionID);
                        }

                        $slider.noUiSlider({
                            range: {
                                'min': 1,
                                'max': answers.length
                            },
                            start: value,
                            step: 1,
                            handles: 1,
                            disabled: disabled
                        }, true);

                        $('.noUi-handle', $(el).closest('td')).text(value);

                        if (disabled) {
                            $slider.attr({'disabled': 'disabled'});
                        } else {
                            $(el).on({
                                change: function(){
                                    var index = parseInt($(this).val()),
                                        rule = function(obj) {
                                            return obj.orderNum === index;
                                        },
                                        answer = answers.filter(rule),
                                        val = answer[0].id;

                                    $('#' + questionID).val(val).prop({'checked': true});
                                    $('.noUi-handle', $(this).closest('td')).text(index);
                                    $('.noUi-target', $(this).closest('td')).addClass('slider-active');
                                    self.validate();
                                },
                                slide: function(){
                                    $('.noUi-target', $(this).closest('td')).addClass('slider-active');
                                }
                            });
                        }

                    }, 5);

                }
            };

            // self.getUserAnswer = function(ID) {
            //     ID = ID || entityVM.ID();
            //     return new CurrentUserAnswer(user.answers, ID);
            // };

// ------------- Main Pagination -------------

            self.showQuizFeedback = ko.observable(false);

            self.isLastQuizTask = function(ID) {
                var entity = null,
                    computedQuizMap = self.quizMap().slice(0),
                    index = computedQuizMap.indexOf(ID),
                    len = computedQuizMap.length;

                if (index === len - 1) {
                    return true;
                }

                index++;

                for ( ; index < len; index++) {
                    entity = training.getEntity(computedQuizMap[index]);

                    if (entity && entity.typeId !== 10) {
                        return false;
                    }
                }

                return true;
            };

            self.getQuizPoints = function(ID) {
                var quizMap = self.quizMapById(ID),
                    quizPoints = 0;

                for (var i=0;i<quizMap.length;i++) {
                    quizPoints += userAnswers.getTaskPoints(quizMap[i]);
                }
                return quizPoints;
            };

            self.quizMapById = function(ID) {
                var progress = userAnswers.getQuizPageProgress(ID);

                return progress.childrenID || [];
            };

            self.showQuizProgress = function() {
                return ( self.isQuizTask() || self.isQuizPage() && self.showQuizFeedback() ) ? true : false;
            };

            self.getQuizProperty = function(prop) {
                var ID          = entityVM.ID(),
                    entity      = null,
                    quizId      = '',
                    getQuizId   = function(ID) {
                        var entity = training.getEntity(ID);

                        if (entity !== null) {
                            if ( entity.typeId === 19) {
                                return entity.contentEntityId;
                            } else if ( entity.contentEntity.parentId !== training.containerID ) {
                                return getQuizId(entity.contentEntity.parentId);
                            } else {
                                return '';
                            }
                        }

                    };

                if ( self.isQuizPage() ) {
                    entity = training.getEntity(ID);
                } else if ( self.isQuizTask() ) {
                    quizId = getQuizId(ID);
                    if (quizId) {
                        entity = training.getEntity(getQuizId(ID));
                    }
                }

                if (entity !== null) {

                    if (entity.hasOwnProperty(prop)) {
                        return entity[prop];
                    } else if ( entity.contentEntity.hasOwnProperty(prop) ) {
                        return entity.contentEntity[prop];
                    } else {
                        return null;
                    }
                }

                return null;
            };

            self.quizPagination = ko.computed(function() {
                var id          = entityVM.ID(),
                    map         = self.quizMap(),
                    paging      = null;

                if ( map && map.length ) {
                    paging = new Pagination(map, id, viewModel);
                }

                if (!self.quizPage) {
                    self.quizPage       = ko.observable();
                    self.quizTotal      = ko.observable();
                    self.quizPrevDisabled = ko.observable(false);
                    self.quizNextDisabled = ko.observable();
                }

                if ( paging ) {
                    self.quizPage(paging.page);
                    self.quizTotal(paging.total);

                    // Get Quiz Page obj & prop

                    if ( !self.getQuizProperty('canSubmitMultipleTimes') ) {
                        self.quizPrevDisabled(true);
                    } else {
                        self.quizPrevDisabled(false);
                    }

                    if ( self.getQuizProperty('enableMovingBackwards') ) {
                        self.quizPrevDisabled(paging.prevDisabled);
                    }

                    self.quizNextDisabled(paging.nextDisabled);
                } else {
                    self.quizPage(0);
                    self.quizTotal(0);
                    self.quizPrevDisabled(true);
                    self.quizNextDisabled(true);
                }

                self.quizRestart = function() {
                    var ID = entityVM.ID(),
                        entity = training.getContent(ID);

                    self.quizRestarting(true);

                    if (helpers.entity.isQuizPage(entity)) {
                        self.quizResetById(ID);
                        self.goToQuizPage(1);
                    } else {
                        self.goTo(entity.parentID);
                    }
                };

                // TODO: remove, unused
                self.quizReset = function() {
                    return self.quizResetById(entityVM.ID());
                };

                self.quizResetById = function(ID) {
                    userAnswers.resetQuizAnswers(ID);
                    userAnswers.resetComputedQuizMap(ID);
                    dataContext.logProgress('sync', ID);
                };

                self.quizPrev = function(swiping) {
                    if (self.quizPrevDisabled()) {
                        return;
                    }

                    if (!!self.getQuizProperty('enableMovingBackwards') && paging ) {
                        self.goTo(null, swiping, 'Back');
                    } else if (self.getQuizProperty('canSubmitMultipleTimes')) {
                        self.goTo(self.parentId(), swiping, 'Back');
                    }
                };

                self.quizNext = function(swiping) {
                    if (self.quizNextDisabled()) {
                        return;
                    }

                    if (paging) {
                        self.goTo(null, swiping, 'Forward');
                    }
                };

                self.goToQuizFeedback = function(swiping) {
                    self.quizRestarting(false);
                    // self.goTo(self.parentId(), swiping, 'Parent');
                    self.goTo(null, swiping, 'Forward');
                };

                self.goToQuizPage = function(target) {
                    var progress = userAnswers.getQuizProgress(entityVM.ID()),
                        targetID = (progress && Array.isArray(progress.childrenID)) ? progress.childrenID[--target] : '';

                    if (!targetID) {
                        return;
                    }

                    self.goTo(targetID);
                };
            });

            self.isTaskCorrect = function(ID) {
                return userAnswers.isTaskCorrect(ID);
            };

            self.quizProgress = ko.computed(function() {
                var isTaskAnswered = self.isTaskAnswered(),
                    index = -1,
                    ID = entityVM.ID(),
                    progress = userAnswers.getQuizProgress(ID),
                    arr = [];

                if (progress) {
                    arr = progress.progress.slice(0);

                    if (entityVM.isQuizTask()) {
                        index = progress.childrenID.indexOf(ID);
                    }
                }

                if (index > -1 && arr.length > index && arr[index] !== 'correct' && arr[index] !== 'incorrect') {
                    arr[index] = 'current';
                }

                return arr;
            }).extend({rateLimit: 0});

            self.quizCorrectTasks = ko.computed(function() {
                var progress = userAnswers.getQuizPageProgress(entityVM.ID()) || {},
                    correct = progress.correct || [],
                    total = 0;

                if (!correct.length) {
                    return total;
                }

                for (var i = 0; i < correct.length; i++) {
                    if (correct[i]) {
                        total++;
                    }
                }

                return total;
            });

            self.isQuizPassed = ko.computed(function() {
                var isTaskAnswered = self.isTaskAnswered(),
                    ID = (entityVM.isQuizTask()) ? entityVM.parentId() : entityVM.ID(),
                    progress = userAnswers.getQuizPageProgress(ID);

                if (progress) {
                    return progress.isPassed;
                } else {
                    return false;
                }
            });

            self.lastQuizProgress = function() {
                var progress = userAnswers.getQuizPageProgress(training.lastQuizPageID);

                return {
                    correctTasks: progress.correct.filter(function(isCorrect) {
                        return isCorrect;
                    }).length,
                    totalTasks: progress.correct.length,
                    isAnswered: progress.isAnswered,
                    isPassed: progress.isPassed
                }
            };

            self.customQuizFeedback = function(progress) {
                var content = helpers.component.getContent(entityVM.componentsJSON(), 'Feedbacks'),
                    arr = helpers.component.parseProp(content, 'feedbacks', 'FeedbackText'),
                    min = 0,
                    score = -1,
                    feedback = '';

                for (var i = 0; i < arr.length; i++) {
                    min = parseFloat(arr[i].score);

                    if (min <= progress.userScore && min > score) {
                        feedback = arr[i].feedback;
                        score = min;
                    }
                }

                return {
                    content: feedback
                }
            };

            self.quizContentText = ko.computed(function() {
                var ID = entityVM.ID(),
                    entity = training.getContent(ID);

                self.showQuizFeedback(false);    // This should be deprecated at some point
                training.showQuizFeedback = false;

                if (helpers.entity.isQuizPage(entity)) {
                    var progress = userAnswers.getQuizPageProgress(ID);

                    if (progress && progress.isAnswered || entityVM.isQuizGame()) {
                        self.showQuizFeedback(true);    // This should be deprecated at some point
                        training.showQuizFeedback = true;

                        var customContent = feedback.getCustomContent(ID, progress.userScore),
                            content = (customContent) ? customContent : (entity.passAlways || progress.userScore >= entity.passThreshold) ? entity.passedFeedback : entity.failedFeedback;

                        if (content) {
                            content = helpers.misc.replaceTextholder(self, userVM, content);
                        }

                        return content;
                    }
                }

                return self.contentText();
            }).extend({rateLimit: 0});

            var requestAnimationFrameID;

            function initLoader(node, duration, ID) {
                var i = node.getTotalLength(),
                    end = new Date().getTime() + duration,
                    step = 0;

                if (requestAnimationFrameID) {
                    window.cancelAnimationFrame(requestAnimationFrameID);
                }

                function load() {
                    var entity = training.getEntity(ID);

                    if (i <= 0) {
                        node.style.strokeDashoffset = 0;
                        window.cancelAnimationFrame(requestAnimationFrameID);
                        self.nextInactive(false);

                        store.dispatch({
                            type: 'SET_ENTITY_ACTIVE'
                        });

                        self.updateVisited(ID, entity);

                        return;
                    }

                    node.style.strokeDashoffset = i;
                    step = ((1000 * i)/((end - new Date().getTime()) * 60));

                    if (step < 0) {
                        i = 0;
                    } else {
                        i -= step;
                    }

                    requestAnimationFrameID = window.requestAnimationFrame(load);
                }

                requestAnimationFrameID = window.requestAnimationFrame(load);
            }

            ko.computed(function () {
                var ID = entityVM.ID(),
                    entity = training.getContent(ID),
                    game = null,
                    paging = null;

                if (entityVM.isQuizGame()) {
                    game = helpers.content.getQuizGame(ID, data.training.contentEntities);
                    ID = (game && game.ID) ? game.ID : ID;
                } else if (entityVM.isQuizTask()) {
                    ID = entityVM.parentId();
                }

                paging = new Pagination(self.trainingMap(), ID, viewModel);

                if (!self.page) {

                    self.page = ko.observable();
                    self.progress = ko.observable();
                    self.prevDisabled = ko.observable();
                    self.nextDisabled = ko.observable();
                    self.total = ko.observable(paging.total);
                }

                self.goTo = function (target, swiping, direction, initPageRender) {
                    var ID = entityVM.ID(),
                        targetID = '',
                        status;

                    if (modal && modal.isVisible()) {
                        return;
                    }

                    window.initPageRender = initPageRender || new Date();

                    if (target && (target === 'Back' || target === 'Forward')) {
                        direction = target;
                        target = null;
                    }

                    targetID = navigation.getTargetID(ID, target, direction);

                    status = navigation.validate({
                        ID: ID,
                        targetID: targetID,
                        direction: direction
                    });

                    if (!status.canContinue) {

                        var mContent = '',
                            mButtons = [],
                            enterClose = true,
                            showClose = false;

                        if (status.type === 'current' || status.type === 'previous') {

                            if (status.type === 'previous') {
                                mContent += lang.missedOne + ' ';
                            }

                            switch(status.reason) {
                                case 'quiz-progress-reset':
                                    mContent += lang.quizRestart;
                                    mButtons.push({action: function() {
                                        var parentID = self.parentId();

                                        self.quizResetById(parentID);
                                        modal.close();
                                        navigation.navigateTo(parentID);

                                    }, class: 'bu bu-alt', text: lang.restart});
                                    mButtons.push({action: function() { modal.close(); }, class: 'bu bu-alt', text: lang.cancel});
                                    break;
                                case 'quiz-game-page-not-passed':
                                    mContent += lang.quizGamePassRequired;
                                    mButtons.push({action: function() { modal.close(); }, class: 'bu bu-alt', text: lang.ok});
                                    break;
                                case 'quiz-page-not-answered':
                                    mContent += lang.quizAnswerRequired;
                                    mButtons.push({action: function() { modal.close(); }, class: 'bu bu-alt', text: lang.ok});
                                    break;
                                case 'quiz-page-in-progress':
                                    mContent += lang.quizAnswerRequired;
                                    mButtons.push({action: function() { modal.close(); }, class: 'bu bu-alt', text: lang.ok});
                                    break;
                                case 'quiz-page-not-passed':
                                    mContent += lang.quizPassRequired;
                                    mButtons.push({action: function() { modal.close(); }, class: 'bu bu-alt', text: lang.ok});
                                    break;
                                case 'task-page-not-answered':
                                    mContent += lang.answerRequired;
                                    mButtons.push({action: function() { modal.close(); }, class: 'bu bu-alt', text: lang.ok});
                                    break;
                                case 'content-page-not-visited':
                                    mContent += (status.reason === 'content-page-not-visited') ? lang.requiredVisit : lang.requiredTask;
                                    mContent = mContent.replace('{target.name}', status.target.title).replace('{required.name}', status.missing.title);

                                    enterClose = false;

                                    mButtons.push({action: function () {modal.close(); paging.goTo(status.missing.ID); }, class: 'bu bu-alt', text: lang.proceed});
                                    mButtons.push({action: function() { modal.close(); }, class: 'bu bu-alt', text: lang.cancel});
                                    break;
                                case 'page-missing-interaction':
                                    mContent += lang.missingInteraction;
                                    mButtons.push({action: function() { modal.close(); }, class: 'bu bu-alt', text: lang.ok});
                                    break;
                                case 'page-is-inactive':
                                    var settings = helpers.state.getComponent(store.getState(), 'navigationsettings') || {};

                                    if (settings.text)  {
                                        mContent += settings.text;
                                        mButtons.push({action: function() { modal.close(); }, class: 'bu bu-alt', text: lang.ok});
                                    }

                                    break;
                                default:
                                // mButtons.push({action: function() { modal.close(); }, class: 'bu bu-alt', text: lang.ok});
                                // mButtons.push({action: function() {
                                //     self.goTo( self.parentId() );
                                //     modal.close(); }, class: 'bu bu-alt', text: lang.restart});
                                // mButtons.push({action: function() { modal.close(); }, class: 'bu bu-alt', text: lang.cancel});
                            }

                            if (status.type === 'previous') {
                                mButtons = [];
                                mButtons.push({action: function() { modal.close(); paging.goTo(status.missing.ID); }, class: 'bu bu-alt', text: lang.return});
                                mButtons.push({action: function() { modal.close(); }, class: 'bu bu-alt', text: lang.cancel});
                            }

                        } else {

                            mContent += (status.reason === 'content-page-not-visited') ? lang.requiredVisit : lang.requiredTask;
                            mContent = mContent.replace('{target.name}', status.target.title).replace('{required.name}', status.missing.title);

                            enterClose = false;

                            mButtons.push({action: function() { modal.close(); paging.goTo(status.missing.ID); }, class: 'bu bu-alt', text: lang.proceed});
                            mButtons.push({action: function() { modal.close(); }, class: 'bu bu-alt', text: lang.cancel});
                        }

                        if (dataContext.debugMode && dataContext.previewMode) {
                            console.warn('Can NOT continue: ' + mContent);
                            console.dir(status);
                        }

                        if (dataContext.debugMode) {
                            mContent += '<br>';
                            mContent += '<br>type: ' + status.type;
                            mContent += '<br>status: ' + status.reason;
                        }

                        if (!dataContext.debugMode || !dataContext.previewMode) {

                            mContent = mContent || ' ';

                            modal = new Modal({
                                content: mContent,
                                enterClose: enterClose,
                                showClose: showClose
                            });

                            if (mButtons.length) {
                                modal.addButtons(mButtons);
                            }

                            if (mContent && mButtons.length) {
                                modal.open();
                            }
                        }
                    }

                    if (status.canContinue || dataContext.debugMode && dataContext.previewMode) {
                        navigation.navigateTo(targetID, swiping, direction);
                    }
                };

                self.next = function (swiping) {
                    if (self.nextDisabled() && !training.modularMenuPageID) {
                        return;
                    }

                    self.goTo(null, swiping, 'Forward');
                };

                /**
                 * Used for alternative navigation that happens inside a page for example changing slide show.
                 * Activated by self.alternativeNavigation(true)
                 * @param {Boolean} swiping - True when navigation by swipe gesture
                 */
                self.nextAlt = function (swiping) {
                    self.next(swiping);
                };

                self.prev = function (swiping) {
                    var target = 'Back';

                    if (self.prevDisabled()) {
                        return;
                    }

                    // self.resetForm();

                    var isLevel1 = helpers.navigation.isLevel1(entityVM.ID(), data.training.contentEntities);

                    if (training.modularMenuPageID && isLevel1){
                        target = training.modularMenuPageID;
                    }

                    self.goTo(target, swiping);
                };

                /**
                 * Used for alternative navigation that happens inside a page for example changing slide show.
                 * Activated by self.alternativeNavigation(true)
                 * @param {Boolean} swiping - True when navigation by swipe gesture
                 */
                self.prevAlt = function (swiping) {
                    self.prev(swiping);
                };

                if (entity.typeID === 19 && !paging.nextDisabled) {
                    var progress = userAnswers.getQuizPageProgress(ID);

                    if (entity.requiresCompletion && progress && !progress.isPassed && !progress.isVisited) {
                        paging.nextDisabled = true;
                    }
                }

                self.page(paging.page);
                self.progress(paging.progress);
                self.prevDisabled(paging.prevDisabled);
                self.nextDisabled(paging.nextDisabled);
            });

            self.isQuizGameSubpage = function() {
                var props = helpers.state.getProps(store.getState());

                return props.isQuizGameSubpage;
            };

            self.nextInactive = ko.observable(false);

            ko.computed(function () {
                var ID = entityVM.ID(),
                    props = helpers.state.getProps(store.getState());

                if (!props.isInactive) {
                    self.nextInactive(false);
                } else {
                    self.nextInactive(true);

                    var subscription = PubSub.subscribe('page-load-complete', function() {
                        var node = document.querySelector('.js-nav-loader'),
                            settings = helpers.state.getComponent(store.getState(), 'navigationsettings') || {},
                            delay = (settings.delay) ? parseFloat(settings.delay) : 0;

                        if (node) {
                            initLoader(node, delay * 1000, ID);
                        }

                        subscription.remove();
                    });
                }
            });

            self.pageIndex = function() {
                var ID = entityVM.ID(),
                    game = null,
                    trainingMap = self.trainingMap(),
                    index = 0,
                    progress;

                if (entityVM.isQuizGame()) {
                    game = helpers.content.getQuizGame(ID, data.training.contentEntities);
                    ID = (game && game.ID) ? game.ID : ID;
                } else if (entityVM.isQuizTask()) {
                    progress = userAnswers.getQuizProgress(ID);
                    if (progress && progress.ID) {
                        ID = progress.ID;
                    }
                }

                index = trainingMap.indexOf(ID) + 1;

                return index + '/' + self.total();
            };

            self.navigateTo = function(id){
                if ( id === 'next' ) {
                    if ( self.isQuizTask() ) {
                        self.quizNext();
                    } else {
                        self.next();
                    }
                } else if ( id === 'prev' ) {
                    if ( self.isQuizTask() ) {
                        self.quizPrev();
                    } else {
                        self.prev();
                    }
                } else {
                    self.goTo( id );
                }
            };



            self.debug = function() {
                var state = store.getState();
                    // props = helpers.state.getProps(state),
                    // settings = helpers.state.getComponent(state, 'tasksettings') || {};

                console.dir(state);
                console.dir(training.getEntity(entityVM.ID()));

                // console.error('debug');
                // console.log('helpers:', helpers.navigation.areChildrenVisited(training.contentEntities, userVM));
                // console.log('userAnswers isSectionVisited:', userAnswers.isSectionVisited(entityVM.ID()));
                // console.log('userAnswers isCourseVisited:', userAnswers.isCourseVisited());
            };

            $(function() {

                var $body = $('body');

                $body.on('click', '.goto', function(e) {
                    var id = $(this).data('id');
                    e.preventDefault();

                    $body.removeClass('nav-menu-open');
                    self.navigateTo(id);
                });

                $body.on('click', '[linktypeid="2"]', function(e) {
                    var id = $(this).attr('linkentityid');
                    e.preventDefault();
                    self.navigateTo( id );
                });

                $body.on('click', '.js-f-label-star', function() {
                    if ( $(this).children('input').prop('disabled') ) {
                        return false;
                    }

                    $(this).siblings().removeClass('f-label-checked').end()
                        .parent('.js-f-col-star').addClass('f-col-chosen').end()
                        .addClass('f-label-checked');
                });

                $body.on('click', '.js-f-col-unknown .f-input', function() {
                    var $row = $(this).closest('tr');

                    if ( !$(this).prev('input').prop('disabled') ) {
                        $row.find('.f-label-star').removeClass('f-label-checked');
                        $row.find('.js-f-col-star').removeClass('f-col-chosen');
                    }
                });

                $('body').on('click', '.hide-box', function(e) {
                    e.preventDefault();
                    $(this).closest('.box').removeClass('open');
                });

                $(document).on('click', '.js-close-player', function(e) {
                    e.preventDefault();

                    modal = new Modal({
                        content: lang.closePlayer
                    });

                    modal.addButtons([
                        {action: function() { window.close(); }, class: 'bu bu-alt', text: lang.yes}
                    ]);

                    modal.open();
                });

                $(document).on('click', '.js-toggle-nav-menu', function(e) {
                    var top = 0,
                        nav = document.getElementById('nav-info'),
                        current;

                    e.preventDefault();

                    if (training.modularMenuPage.hideToc && training.modularMenuPage.ID) {
                        if (training.modularMenuPage.ID === entityVM.ID()) {
                            return;
                        }

                        // TODO: remove
                        self.naviTargetId(training.modularMenuPage.ID);
                        self.goTo(entityVM.naviTargetId());
                        // END TODO

                        // should be:
                        // self.goTo(training.modularMenuPage.ID);

                    } else {
                        dialog.close({
                            type: 'dialog'
                        });

                        document.body.classList.toggle('nav-menu-open');

                        if (nav) {
                            current = nav.querySelector('.nav-current');
                            if (current) {
                                current.classList.remove('nav-current');
                            }
                        }

                        setTimeout(function() {
                            top = ($('.nav-current').length) ? $('.nav-current').offset().top - 80 : 0;
                            $('.js-nav').animate({scrollTop: top}, 0);
                        }, 0);
                    }
                });

                $(document).on('click', '.js-open-comment-tool', function(e) {
                    var ctopen = commentTool.open();
                    e.preventDefault();
                    if( ctopen !== 'ok' ){

                        modal = new Modal({
                            content: lang.commentToolError.replace('{ctopen}', ctopen),
                            showClose: false
                        });

                        modal.addButtons([
                            {action: function() { modal.close(); }, class: 'bu bu-alt', text: lang.close}
                        ]);

                        modal.open();
                    }
                });

            });

            var toggleTextarea = function() {
                var box = document.querySelector('.js-textarea-box');

                if (!box) {
                    return;
                }

                var parent = box.parentNode,
                    readonly = !box.checked,
                    texterea = parent.querySelector('.js-textarea');

                if (!texterea) {
                    return;
                }

                texterea.readOnly = readonly;
            }

            document.body.addEventListener('change', function(e) {
                var target = e.target;

                if (target.classList.contains('js-toggle-textarea')) {
                    toggleTextarea();
                }
            });

            // Key bindings for navigation with keyboard arrows
            $(document).keydown(function(e){
                if(self.allowKeyboardShorts() && !(entityVM.isQuizGame() && (entityVM.isQuizPage() || entityVM.isQuizTask()))) {
                    var tag = e.target.tagName.toLowerCase();
                    if (tag !== 'input' && tag !== 'textarea') {
                        switch (e.which) {
                        case 8:     // backspace
                            if (!self.isQuizTask()) {
                                self.prev();
                            }
                            break;
                        case 27:    // escape
                            // hideFeedback(); // hide boxes
                            break;
                        case 37:    // left arrow
                            if (self.isQuizTask()) {
                                self.quizPrev();
                            } else {
                                self.prev();
                            }
                            break;
                        case 39:    // right arrow
                            if (self.isQuizTask()) {

                                if (self.quizNextDisabled()) {
                                    self.goToQuizFeedback();
                                } else {
                                    self.quizNext();
                                }
                            } else {
                                self.next();
                            }
                            break;
                        default:
                            return;
                        }
                        e.preventDefault();
                    }
                }
            });

// ------------- END Main Pagination -------------

            commentTool.init($, self);

            if (dataContext.svgsInIndexHtml == true) {
                $(document).ready(function() {
                    var $offlineSVGEls = $('div#embedded-svgs svg');

                    window.offlineSVGs = {};

                    $offlineSVGEls.each(function(index){
                        var svg = $offlineSVGEls[index],
                            svgName = svg.getAttribute('data-file-name')

                        if (svgName) {
                            window.offlineSVGs[svgName] = svg.outerHTML || $('<div>').append($(svg).clone()).html();
                        }

                        $(svg).remove();
                    });
                });
            }

            self.setNaviTargetId = function(){
                var targetId,
                    isSectionLastPage = helpers.navigation.isSectionLastPage(entityVM.ID(), data.training.contentEntities);

                if(training.modularMenuPageID && (isSectionLastPage || self.showQuizFeedback())){
                    targetId = training.modularMenuPageID === null;
                }else{
                    targetId = self.defaultNaviTargetId();
                }
                self.naviTargetId(targetId);
            };

            ko.computed(function() {
                self.setNaviTargetId();
                commentTool.changed($, self);
            });

        };

    });

